export default (() => {

  class CardView {
    constructor() {
      this.dom = {
      preloadClass: document.querySelectorAll('.js-cards-preloading'),
      target:  document.querySelectorAll('.js-grid-target'),
      triggers: Array.from(document.querySelectorAll('.js-grid-trigger'))
      };
      this.allClasses = [];
    }

    getTriggers() {
      this.dom.triggers.forEach(el => {
        const classToAdd = el.dataset.grid;
        this.allClasses.push(classToAdd);
        this.bindClick(el, classToAdd);
      });
    }

    bindClick(el, classToAdd) {
      el.addEventListener('click', e => {
        e.stopPropagation();
        this.setActive(classToAdd);
        this.toggleGrid(classToAdd);
      });
    }

    setActive(activeClass) {
      document.cookie = `cardview=${activeClass}; path=/;`;
      this.dom.triggers.forEach(el => {
        el.classList.remove('active');
        if(el.dataset.grid == activeClass) {
          el.classList.add('active');
        }
      });
    }

    toggleGrid(newClass) {
      const classesToRemove = this.allClasses.filter(e => {return e != newClass});
      this.dom.target.forEach(el => {
      el.classList.remove(...classesToRemove);
      el.classList.add(newClass);
      });
    }

    init() {
      if (this.dom.triggers.length) {
        this.getTriggers();
        const cardviewCookie = window.getCookie('cardview');

        if (cardviewCookie) {

          this.dom.triggers.forEach(el => {
            el.classList.remove('active');
            if(el.dataset.grid == cardviewCookie) {
              el.classList.add('active');
            }
          });

          this.toggleGrid(cardviewCookie);
        }
      }
      if (this.dom.preloadClass.length > 0) {
        this.dom.preloadClass.forEach(el => {
          el.classList.remove('js-cards-preloading');
        });
      }
    }
  }

  const cardView = new CardView();
  cardView.init();
})()
